module.exports = __webpack_public_path__ + "img/alarm-message.2c56aa9e.svg";